import React from 'react';
import { Spinner } from '@fluentui/react';
import useAxios from 'axios-hooks';
import { useRouteMatch, useHistory } from 'react-router-dom';
import EmlSendersTable from '../Components/EmlSendersTable';

const DefaultPage = () => {
    const history = useHistory();
    let { url } = useRouteMatch();

    const [{ data: emlSenders, loading }, refetch] = useAxios("/emails/email-senders");

    if (loading) return <Spinner className="absolute-center" label="Loading Email Senders..." />;

    return (
        <>
            <EmlSendersTable
                emlSenders={emlSenders}
                createOnClick={() => history.push(`${url}/wizard`)}
                editOnClick={(id) => history.push(`${url}/${id}/wizard`)}
                loading={loading}
            />
        </>
    );
};

export default DefaultPage;
